import axios from 'axios';
import { DepositTransaction } from 'react-easyrocket';
import { HellocleverResponse } from 'src/types';
import { HELLOCLEVER_PAYMENT_METHOD } from '../constants';
import { useModalContext } from 'src/hooks/useModalContext';

export function useProcessHelloclever() {
  const { openModal } = useModalContext();
  return async ({
    transaction,
    checkoutUrl,
    paymentMethodName,
    data
  }: {
    transaction?: DepositTransaction;
    checkoutUrl?: string;
    paymentMethodName?: string;
    data: { [key: string]: string | undefined };
  }) => {
    if (transaction?.paymentMethod !== HELLOCLEVER_PAYMENT_METHOD || !checkoutUrl) return;
    try {
      const instance = axios.create({});
      const response = await instance.post<HellocleverResponse>(checkoutUrl, data);
      openModal('DEPOSIT_HELLOCLEVER_RESULT', {
        props: {
          ...response.data,
          paymentMethodName
        }
      });
    } catch (error) {
      console.error(error);
      const failUrl = data['fail_url'];
      if (failUrl) {
        window.open(failUrl);
      }
    }
  };
}
